import { useContext } from 'react';

import HistoryContext from 'contexts/historyContext';

type Return = {
  previousFullUri?: string;
  previousPath?: string; // It's used for GTM (page referrer)
  previousPage?: string; // The value does not change when the color is changed
  changeColorCounter: number; // It's used to use history.go(-X) instead of history.back()
  isLoaded: boolean;
};

export default function useHistory(): Return {
  const {
    previousPath,
    previousPage,
    changeColorCounter,
    isLoaded,
  } = useContext(HistoryContext);

  return {
    previousFullUri: previousPath
      ? `${window.location.origin}${previousPath}`
      : undefined,
    previousPath,
    previousPage: changeColorCounter === 0 ? previousPath : previousPage,
    changeColorCounter,
    isLoaded,
  };
}
